import Link from "next/link";
import React, { useContext, useState, useTransition } from "react";
import { useEffect } from "react";
import { Button } from "react-bootstrap";
import helper from "../../lib/helper";
import notificationModel from "../../models/notifications.model";
import useSWR from "swr";
import Pagination from "../../components/Pagination";
import Heading from "../../components/Heading";
import Table from "../../components/Table";
import { useRouter } from "next/router";
import config from "../../lib/config";
import moment from "moment/moment";
const Page = function () {
    const [showLoader, setShowLoader] = useState(false);

    const router = useRouter();
    const queryParams = router.query;
    const { data: notificationData, mutate: notificationPageData, isLoading } = useSWR(
        queryParams || null,
        () => notificationModel.list(queryParams),
        config.swrConfig
    );

    console.log(notificationData)

    const columns = [
        {
            Header: 'Title',
            accessor: 'title',
            className: 'col'
        },
        {
            Header: 'Event',
            accessor: 'event',
            className: 'col'
        },
        {
            Header: "Date",
            id: "created_at",
            Cell: ({ row }) => (
                <>
                    <div>
                        {helper.date.format(row.original.created_at)}
                    </div>
                </>
            )
        },

        {
            className: "col-auto text-end",
            Header: "Actions",
            id: "action",
            Cell: ({ row }) => (
                <>
                    <div className="btn-group btn-group-sm">

                        <Link
                            className="btn btn-warning"
                            href={`/notificationtemplate/${row.original.id}/edit`}
                        >
                            <i className="bi bi-pencil-square"></i>
                        </Link>
                        <button
                            className="btn btn-danger"
                            onClick={() => confirmDelete(row.original.id, row.original.title)}
                        >
                            <i className="bi bi-trash"></i>
                        </button>
                    </div>
                </>
            ),
        },


    ]
    const confirmDelete = async (id, title) => {
        await helper.sweetalert
            .confirm(`confirm to delete ${title}`, "warning")
            .then(async (result) => {
                if (result.isConfirmed) {
                    setShowLoader(true);
                    await notificationModel.destroy(id).then((res) => {
                        notificationPageData();
                        helper.sweetalert.toast(`${title} deleted Successfully`);
                    });
                    setShowLoader(false);
                }
            });
    };

    return (
        <>
            <Heading title="NotificationTemplates" showLoader={isLoading || showLoader}>
                <Button className="btn btn-primary btn-sm" href="/notificationtemplate/create">
                    <i className="bi bi-plus" />Create
                </Button>
            </Heading>
            <div className="container-fluid">
                <div className="card">
                    <div className="card-header">Template List</div>
                    <div className="table-responsive">
                        <Table columns={columns} data={notificationData?.data || []} />
                    </div>
                    <div className="card-footer">
                        <Pagination meta={notificationData?.meta} />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;







